import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'l-user',
    imports: [RouterOutlet],
    template: `<router-outlet></router-outlet>`
})
export class UserComponent {}
